(function () {
  if (!document.body) return;

  var isCollectionTemplate = document.body.classList.contains('template-collection');
  var isSearchTemplate = document.body.classList.contains('template-search');

  if (!isCollectionTemplate && !isSearchTemplate) return;
  if (window.DDLACollectionMobileViewToggleLoaded) return;
  window.DDLACollectionMobileViewToggleLoaded = true;

  var STORAGE_KEY = 'ddla_collection_mobile_view_mode';

  function getSavedMode() {
    try {
      var saved = window.localStorage.getItem(STORAGE_KEY);
      return saved === 'full' ? 'full' : 'grid';
    } catch (e) {
      return 'grid';
    }
  }

  function saveMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      // Ignore storage errors in private mode.
    }
  }

  function updateToggleButtons(mode) {
    var toggles = document.querySelectorAll('[data-collection-view-toggle]');

    toggles.forEach(function (toggleRoot) {
      var buttons = toggleRoot.querySelectorAll('[data-collection-view-mode]');
      buttons.forEach(function (button) {
        var isActive = button.getAttribute('data-collection-view-mode') === mode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  }

  function closeOpenMobileFacetsDrawer() {
    var openDrawer = document.querySelector('.mobile-facets__wrapper details[open]');
    if (!openDrawer) {
      document.body.classList.remove('overflow-hidden-mobile');
      return;
    }

    var menuDrawer = openDrawer.closest('menu-drawer');
    var summary = openDrawer.querySelector('summary');

    if (menuDrawer && typeof menuDrawer.closeMenuDrawer === 'function' && summary) {
      menuDrawer.closeMenuDrawer(new Event('click'), summary);
    } else {
      openDrawer.classList.remove('menu-opening');
      openDrawer.removeAttribute('open');
    }

    document.body.classList.remove('overflow-hidden-mobile');
  }

  function refreshCollectionCardMedia() {
    if (!window.CollectionCardMedia || typeof window.CollectionCardMedia.refresh !== 'function') return;

    document.querySelectorAll('[data-collection-card-carousel]').forEach(function (mediaElement) {
      window.CollectionCardMedia.refresh(mediaElement);
    });
  }

  function applyMode(mode) {
    var productGrid = document.getElementById('product-grid');
    if (!productGrid) {
      updateToggleButtons(mode);
      return;
    }

    productGrid.classList.toggle('collection-mobile-full', mode === 'full');
    productGrid.classList.toggle('collection-mobile-grid', mode !== 'full');
    updateToggleButtons(mode);

    // Ensure carousel dimensions are recalculated after card widths change.
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(refreshCollectionCardMedia);
      });
    } else {
      setTimeout(refreshCollectionCardMedia, 0);
    }
  }

  function applySavedMode() {
    applyMode(getSavedMode());
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-collection-view-mode]');
    if (!button) return;

    var toggleRoot = button.closest('[data-collection-view-toggle]');
    if (!toggleRoot) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var mode = button.getAttribute('data-collection-view-mode') === 'full' ? 'full' : 'grid';
    closeOpenMobileFacetsDrawer();
    saveMode(mode);
    applyMode(mode);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySavedMode);
  } else {
    applySavedMode();
  }

  var productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer && 'MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      var shouldReapply = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.id === 'product-grid' || node.querySelector('#product-grid') || node.querySelector('[data-collection-view-toggle]')) {
            shouldReapply = true;
          }
        });
      });

      if (shouldReapply) {
        applySavedMode();
      }
    });

    observer.observe(productGridContainer, { childList: true, subtree: true });
  }
})();
